export const SPECS = {
  CallCartV2FromCheckout: 'specs.ecom.CallCartV2FromCheckout',
  CartTooltipWithoutNumber: 'specs.stores.CartTooltipWithoutNumber',
  CartOOIThunderboltCSSOptimization: 'specs.stores.CartOOIThunderboltCSSOptimization',
  ShouldUseOpenSideCartApiInAddToCart: 'specs.stores.ShouldUseOpenSideCartApiInAddToCart',
  ShouldUseEcomPlatformPublicApiAddToCartInPP: 'specs.stores.ShouldUseEcomPlatformPublicApiAddToCartInPP',
  AddSlotToCartPage: 'specs.stores.AddSlotToCartPage',
  ExpressCheckoutInSideCart: 'specs.stores.ExpressCheckoutInSideCart',
  SideCartElementsVisibilityInCss: 'specs.stores.SideCartElementsVisibilityInCss',
  MapCartSummaryColors: 'specs.stores.MapCartSummaryColors',
  GiftCardAddToCartSettings: 'specs.stores.ShowGiftCardAddToCartSettings',
  FixHandleCreateCheckoutError: 'specs.ecom.FixHandleCreateCheckoutError',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  SideCartEditor3SettingsPanel: 'specs.ecom.SideCartEditor3SettingsPanel',
  SideCartEditor3HideSettingsDesignPanel: 'specs.ecom.SideCartEditor3HideSettingsDesignPanel',
  MoveGetClientConfigToControllerFactory: 'specs.ecom.MoveGetClientConfigToControllerFactory',
  PreloadOnCartCheckoutButton: 'specs.ecom.PreloadOnCartCheckoutButton',
  MoveCartToViewerContext: 'specs.ecom.MoveCartToViewerContext',
  OnlyCallDeliverySolutionsWhenNeededOnCart: 'specs.ecom.OnlyCallDeliverySolutionsWhenNeededOnCart',
  StopSendingOriginInCheckoutUrl: 'specs.ecom.StopSendingOriginInCheckoutUrl',
  CallCartV2FromCartComponents: 'specs.ecom.CallCartV2FromCartComponents',
  TaxBreakdownInCartPage: 'specs.ecom.TaxBreakdownInCartPage',
  ChangeCartLoaders: 'specs.ecom.ChangeCartLoaders',
  TopCheckoutButtonSkeletonOnCart: 'specs.ecom.TopCheckoutButtonSkeletonOnCart',
  StopFocusOnCart: 'specs.ecom.StopFocusOnCart',
  PricesIncludeTaxFromCart: 'specs.ecom.PricesIncludeTaxFromCart',
  ShowFormsPerLineItemsStep: 'specs.ecom.ShowFormsPerLineItemsStep',
  PlatformFeeOnCartAndCheckout: 'specs.ecom.PlatformFeeOnCartAndCheckout',
  FixOutOfStockOnCart: 'specs.ecom.FixOutOfStockOnCart',
  ShowTwoDescriptionLinesOnCartAndCheckout: 'specs.ecom.ShowTwoDescriptionLinesOnCartAndCheckout',
  ShowCheckoutOnEditorPreview: 'specs.ecom.ShowCheckoutOnEditorPreview',
} as const;
